import { createSagaAction } from '../../shared/sagas'
import { createReducer } from '../../shared/reducers'

// Constants
export const constants = {
  JOBS_REFRESH: createSagaAction('JOBS_REFRESH'),
  CREATE_JOB: createSagaAction('CREATE_JOB')
}

// Action Creators
export const actions = {
  jobsRefresh: ({ next }) => ({ type: constants.JOBS_REFRESH.ACTION, next }),
  createJob: ({ content, userId }) => ({
    type: constants.CREATE_JOB.ACTION,
    content,
    userId
  })
}

// Reducer
const initialState = [
  {
    name: ''
  }
]

export default createReducer(initialState, (state, { type, payload }) => {
  switch (type) {
    default:
      return state
    case constants.JOBS_REFRESH.SUCCESS:
      return { ...state, payload }
    case constants.CREATE_JOB.SUCCESS:
      return { ...state, payload }
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/jobs.js